export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_USERINFO = 'SET_USERINFO';
export const SET_LOGIN = 'SET_LOGIN';
export const SET_USERID = 'SET_USERID';